module.exports = __webpack_public_path__ + "img/dobrova.b6a2ef6f.jpg";